import {
    CUSTOMERFACINGSURVEY_LOAD,
    CUSTOMERFACINGSURVEY_UNLOAD,
    CUSTOMERFACINGSURVEY_SETACCESSKEY
} from '../../../../actionDefinitions';
import { createReducer } from '../../../../reducerUtils';

export const initialState = {
    survey: undefined,
    surveyForms: undefined,
    customerLink: undefined
};

const handlers = {
    [CUSTOMERFACINGSURVEY_LOAD]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return action.payload;
    },
    [CUSTOMERFACINGSURVEY_UNLOAD]: () => initialState,
    [CUSTOMERFACINGSURVEY_SETACCESSKEY]: (state, action) => {
        return { accessKey: action.payload };
    }
};

export default createReducer(initialState, handlers);
